// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel___3_aoS","heading":"heading___1-sjf"};